import React from "react";
import moment from "moment-timezone";
import Calendar from "./calendar/Calendar";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import update from "immutability-helper";
//import "moment-timezone/node_modules/moment/locale/fr";
import "moment/locale/fr";

import AddRdvModal from "./AddSlotModal";
import "../../styles/calendar.css";
//import SlotModal from "./SlotModal";
import HistoryRdvModal from "./HistoryRdvModal";
import TypesTags from "./TypesTags";
import EmptySlotModal from "./EmptySlotModal";

moment.locale("fr");

const REAL_TIME_IS_ACTIVE = true;

class DoctorCalendar extends React.Component {
  //  static defaultProps = {};
  constructor(props) {
    super(props);

    let selectedDoctorId = null;
    if (props.getSelectedRdv.rdvSelect.selectedRdvTypeId !== null) {
      const type = props.allSlotTypes.find((t) => {
        return t.id === props.getSelectedRdv.rdvSelect.selectedRdvTypeId;
      });
      if (type) {
        selectedDoctorId = type.doctor.id;
      }
    }

    this.state = {
      events: [],
      slots: [],
      isDraggingId: null,
      //maxDate: moment().add(this.props.options.daysAhead, "day"),
      now: moment(this.props.getSelectedRdv.rdvSelect.selectedDate) || moment(),
      week: {},
      showAddModal: false,
      isModalOpen: false,
      isEmptyModalOpen: false,
      selectedEvent: null,
      selectedDoctorId: selectedDoctorId,
      loading: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.doctorId !== nextProps.doctorId) {
      this.initSlotSubscription(nextProps.doctorId);
    }

    let isLoadingNext =
      nextProps.allSlotsQuery.loading ||
      nextProps.getCustomSlots.loading ||
      nextProps.getSpecialDays.loading;
    let isLoadingThis =
      this.props.allSlotsQuery.loading ||
      this.props.getCustomSlots.loading ||
      this.props.getSpecialDays.loading;

    if (isLoadingNext !== isLoadingThis) {
      return true; //false
    }
    if (isLoadingNext) {
      return false;
    }
    if (this.state.isEmptyModalOpen !== nextState.isEmptyModalOpen) {
      return true;
    }
    if (this.state.isModalOpen !== nextState.isModalOpen) {
      return true;
    }
    if (this.state.showAddModal !== nextState.showAddModal) {
      return true;
    }
    if (
      this.props.allSlotsQuery.allSlots.length !==
      nextProps.allSlotsQuery.allSlots.length
    ) {
      return true;
    }

    if (
      this.props.getSelectedRdv.rdvSelect.selectedPatientId !==
      nextProps.getSelectedRdv.rdvSelect.selectedPatientId
    ) {
      return true;
    }

    if (
      !moment(this.props.selectedRdvDate).isSame(
        moment(nextProps.selectedRdvDate)
      )
    ) {
      return true;
    }
    if (
      this.props.getSelectedRdv.rdvSelect.selectedRdvTypeId !==
      nextProps.getSelectedRdv.rdvSelect.selectedRdvTypeId
    ) {
      return true;
    }
    return false;
  }
  componentDidMount() {}

  moveEvent = (slotId, start) => {
    //should we validte the new date
    const id = slotId; //event.slotId;
    const startTime = start;
    this.props.updateSlot({
      variables: { id, startTime },
    });

    //  this.handleChangeRdvType(null);
  };

  handleNavigate = (date) => {
    let selectedDate = date.valueOf();
    let selectedView = "day";
    this.props
      .updateRdvSelect({
        variables: { selectedDate, selectedView },
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };
  handleChangePatient = async (selectedPatient) => {
    //  this.setState({ selectedPatient });
    let selectedPatientId = null;
    let patients = []; //eslint-disable-line
    if (selectedPatient !== null) {
      selectedPatientId = selectedPatient.id;
      patients = [selectedPatient];
    }
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    let selectedDoctorId = null;
    const selectedDate = this.props.getSelectedRdv.rdvSelect.selectedDate;

    this.props
      .updateRdvSelect({
        variables: {
          selectedPatientId,
          selectedRdvTypeId,
          selectedRdvTypeDuration,
          selectedDoctorId,
          selectedDate,
        },
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };

  componentWillMount() {
    let doctorId = this.props.doctorId;
    this.initSlotSubscription(doctorId);
  }

  initSlotSubscription = (doctorId) => {
    if (REAL_TIME_IS_ACTIVE) {
      this.props.allSlotsQuery.subscribeToMore({
        document: gql`
          subscription slotSub($doctorId: ID!) {
            Slot(
              filter: {
                mutation_in: [CREATED, UPDATED, DELETED]
                node: { doctor: { id: $doctorId } }
              }
            ) {
              mutation
              previousValues {
                id
              }
              updatedFields
              node {
                id
                startTime
                createdAt
                duration
                takenBy
                comment
                color
                status
                doctor {
                  id
                  name
                }
                patient {
                  id
                  nom
                  prenom
                  matricule
                }
                slotType {
                  id
                  name
                  doctor {
                    id
                  }
                  duration
                }
              }
            }
          }
        `,
        variables: { doctorId },

        updateQuery: (previousState, { subscriptionData }) => {
          let TYPE = subscriptionData.data.Slot.mutation;
          let toReturn = previousState;
          const slot = subscriptionData.data.Slot.node;
          const slotDate = moment(slot.startTime);
          let start = moment(this.props.selectedRdvDate).startOf(
            this.props.selectedView
          );
          let end = start.clone().endOf(this.props.selectedView);
          if (slot.status === "REMOVED") {
            TYPE = "DELETED";
          }

          if (!slotDate.isBetween(start, end)) {
            //slot outside of current view dates
            return {
              allSlots: previousState.allSlots,
            };
          }

          if (TYPE === "DELETED") {
            toReturn = {
              ...previousState,
              allSlots: [
                ...previousState.allSlots.filter((slot) => {
                  return (
                    slot.id !== subscriptionData.data.Slot.previousValues.id
                  );
                }),
              ],
            };
          } else if (TYPE === "UPDATED") {
            /*this.state.selectedEvent null check*/
            if (
              this.state.selectedEvent &&
              this.state.selectedEvent.slotId === slot.id
            ) {
              let selectedEvent = this.state.selectedEvent;
              selectedEvent.comment = slot.comment;
              selectedEvent.color = slot.color;
              selectedEvent.patient = slot.patient;
              this.setState({ selectedEvent });
            }
            const i = previousState.allSlots.findIndex((s) => {
              if (s !== null) {
                return slot.id === s.id;
              }
              return false;
            });
            toReturn = {
              allSlots: update(previousState.allSlots, { [i]: { $set: slot } }),
            };
          } else {
            //  const newSlot = subscriptionData.data.Slot.node;
            let newSlots = [
              ...previousState.allSlots,
              {
                ...slot,
              },
            ];
            newSlots.sort(function (s, s2) {
              return moment(s.startTime).diff(moment(s2.startTime));
            });

            toReturn = {
              allSlots: newSlots,
            };
          }
          if (toReturn) {
            this.forceUpdate();
            return toReturn;
          }
        },
        onError: (err) => {
          console.error(err);
        },
      });
    }
  };

  toggleModal = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };
  toggleEmptyModal = () => {
    this.setState({ isEmptyModalOpen: !this.state.isEmptyModalOpen });
  };
  toggleAddModal = () => {
    this.setState({ showAddModal: !this.state.showAddModal });
  };
  availableSlotClick = (type, date, slotTypes, id, originalSlotTypes) => {
    this.props.removeNotification();
    const selectedRdvTypeId = this.props.getSelectedRdv.rdvSelect
      .selectedRdvTypeId;
    if (
      selectedRdvTypeId === null &&
      (type === "available" ||
        type === "closed" ||
        type === "customFree" ||
        type === "customClosed" ||
        type === "unavailable")
    ) {
      this.setState({
        selectedEvent: {
          start: date,
          slotTypes: slotTypes,
          id: id,
          originalSlotTypes: originalSlotTypes,
        },
        isEmptyModalOpen: !this.state.isEmptyModalOpen,
      });
    } else if (
      selectedRdvTypeId !== null &&
      (type === "available" || type === "customFree")
    ) {
      this.setState({
        selectedEvent: { start: date },
        showAddModal: !this.state.showAddModal,
      });
    } else {
      this.setState({
        selectedEvent: { start: date, slotTypes: slotTypes },
        isEmptyModalOpen: !this.state.isEmptyModalOpen,
      });
    }
  };
  updateSelectedTypeId = (selectedRdvType, isDraggingId = null) => {
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    //    let selectedDoctorId = null;
    if (selectedRdvType !== null && selectedRdvType !== undefined) {
      selectedRdvTypeId = selectedRdvType.id;
      selectedRdvTypeDuration = selectedRdvType.duration;
    }
    this.setState({
      isDraggingId,
    });
    this.props
      .updateRdvSelectType({
        variables: {
          selectedRdvTypeId,
          selectedRdvTypeDuration,
          //    selectedDoctorId
        },
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };
  handleChangeRdvType = (selectedRdvType) => {
    //this.setState({ selectedRdvType });
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    //    let selectedDoctorId = null;
    if (selectedRdvType !== null && selectedRdvType !== undefined) {
      selectedRdvTypeId = selectedRdvType.id;
      selectedRdvTypeDuration = selectedRdvType.duration;
    }

    this.props
      .updateRdvSelectType({
        variables: {
          selectedRdvTypeId,
          selectedRdvTypeDuration,
          //    selectedDoctorId
        },
      })
      .then(() => {
        if (selectedRdvTypeId !== null) {
          this.props.notify(
            selectedRdvTypeId,
            selectedRdvTypeDuration,
            this.props.doctorId,
            this.props.week.id,
            this.props.options.baseDuration,
            this.props.options.daysAhead,
            this.setEvent,
            this.props.options.minTimeAdmin,
            this.props.options.maxTimeAdmin
          );
        } else {
          this.props.removeNotification();
        }
        //      this.setState({ selectedDoctorId });
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };

  setEvent = (date) => {
    this.setState({
      selectedEvent: { start: date },
      showAddModal: !this.state.showAddModal,
    });
  };

  render() {
    let loading = false;
    if (
      this.props.allSlotsQuery.loading ||
      this.props.getCustomSlots.loading ||
      this.props.getSpecialDays.loading
    ) {
      loading = true;
    }

    let typesTags = (
      <TypesTags
        selectedTypeId={this.props.getSelectedRdv.rdvSelect.selectedRdvTypeId}
        singleValue={true}
        allSlotTypes={this.props.allSlotTypes}
        handleTypeTagChange={this.handleChangeRdvType}
        centered={true}
      />
    );
    let typesStyle = "columns " + this.props.typesStyle;
    let marginTop = "40px";
    if (this.props.title !== null) {
      marginTop = "95px";
    }
    let events = this.props.allSlotsQuery.allSlots;

    return (
      <div>
        <div
          className={typesStyle}
          style={{
            left: this.props.typesStyleLeft + "%",
            width: this.props.typesStyleWidth + "%",
          }}
          ref={(node) =>
            this.props.addRef(
              node,
              this.props.doctorId,
              this.props.typesStyleLeft + "%"
            )
          }
        >
          <div className="column">
            {this.props.title}
            {this.props.getSelectedRdv.rdvSelect.selectedPatientId ? (
              typesTags
            ) : (
              <p className="info-cal">Sélectionnez un patient</p>
            )}
          </div>
        </div>

        <Calendar
          draggingEventId={this.state.isDraggingId}
          marginTop={marginTop}
          handleNavigate={this.handleNavigate}
          baseDuration={this.props.options.baseDuration}
          minTimeAdmin={this.props.options.minTimeAdmin}
          maxTimeAdmin={this.props.options.maxTimeAdmin}
          availableSlotClick={this.availableSlotClick}
          eventSlotClick={(slot) => {
            this.setState({
              selectedEvent: slot.event,
              isModalOpen: !this.state.isModalOpen,
            });
          }}
          moveEvent={this.moveEvent}
          updateSelectedTypeId={this.updateSelectedTypeId}
          date={moment(this.props.selectedRdvDate)}
          week={this.props.week}
          loading={loading}
          view={this.props.selectedView}
          events={events}
          customSlots={this.props.getCustomSlots.allCustomSlots}
          specialDays={this.props.getSpecialDays.allSpecialDays || []}
          selectedTypeId={this.props.getSelectedRdv.rdvSelect.selectedRdvTypeId}
          selectedTypeDuration={
            this.props.getSelectedRdv.rdvSelect.selectedRdvTypeDuration
          }
        />

        {this.state.selectedEvent && this.state.isModalOpen ? (
          <HistoryRdvModal
            handleChangePatient={this.handleChangePatient}
            toggleChatModal={this.props.toggleChatModal}
            userName={this.props.userName}
            event={this.state.selectedEvent}
            patientId={
              this.state.selectedEvent.patient
                ? this.state.selectedEvent.patient.id
                : ""
            }
            isModalOpen={this.state.isModalOpen}
            toggleModal={this.toggleModal}
            hasRdv={true}
            closeHistoryModal={this.toggleModal}
          />
        ) : (
          ""
        )}
        {this.state.isEmptyModalOpen ? (
          <EmptySlotModal
            event={this.state.selectedEvent}
            isModalOpen={this.state.isEmptyModalOpen}
            toggleModal={this.toggleEmptyModal}
            doctorId={this.props.doctorId}
            refetchCustomSlots={this.props.getCustomSlots.refetch}
          />
        ) : null}
        {/*  ) : (
          ""
        )*/}
        {this.state.showAddModal ? (
          <AddRdvModal
            userName={this.props.userName}
            doctorId={this.state.selectedDoctorId || this.props.doctorId}
            toggleModal={this.toggleAddModal}
            selectedPatientId={
              this.props.getSelectedRdv.rdvSelect.selectedPatientId
            }
            selectedEvent={this.state.selectedEvent}
            selectedRdvTypeId={
              this.props.getSelectedRdv.rdvSelect.selectedRdvTypeId
            }
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const UPDATE_SLOT = gql`
  mutation updateSlot($id: ID!, $startTime: DateTime!) {
    updateSlot(id: $id, startTime: $startTime) {
      id
    }
  }
`;

const UPDATE_RDV_SELECT_DATE = gql`
  mutation updateRDVSelect($selectedDate: Int) {
    updateRDVSelect(selectedDate: $selectedDate) @client
  }
`;

const UPDATE_RDV_SELECT = gql`
  mutation updateRDVSelect(
    $selectedDate: Int
    $selectedPatientId: String
    $selectedDoctorId: String
    $selectedRdvTypeId: String
    $selectedView: String
    $selectedRdvTypeDuration: Int
  ) {
    updateRDVSelect(
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
      selectedDoctorId: $selectedDoctorId
      selectedDate: $selectedDate
      selectedView: $selectedView
      selectedPatientId: $selectedPatientId
    ) @client
  }
`;
const UPDATE_RDV_SELECT_TYPE = gql`
  mutation updateRDVSelectTypeDoc(
    $selectedRdvTypeId: String
    $selectedRdvTypeDuration: Int
    $selectedDoctorId: ID
  ) {
    updateRDVSelectTypeDoc(
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
      selectedDoctorId: $selectedDoctorId
    ) @client
  }
`;

const GET_SELECTED_RDV = gql`
  query {
    rdvSelect @client {
      selectedDate
      selectedPatientId
      selectedRdvTypeId
      selectedRdvTypeDuration
      selectedView
    }
  }
`;
const ALL_SLOTS = gql`
  query GetAllSlotsQuery($doctorId: ID!, $now: DateTime!, $then: DateTime!) {
    allSlots(
      orderBy: startTime_ASC
      filter: {
        AND: [
          { doctor: { id: $doctorId } }
          { startTime_gte: $now }
          { startTime_lte: $then }
          { status_not: REMOVED }
        ]
      }
    ) {
      id
      startTime
      createdAt
      duration
      comment
      takenBy
      status
      color
      patient {
        id
        nom
        prenom
        matricule
      }
      slotType {
        id
        name
        duration
        doctor {
          id
        }
      }
      doctor {
        id
      }
    }
  }
`;
const GET_CUSTOM_SLOTS = gql`
  query GetCustomSlotQuery($doctorId: ID!, $now: DateTime!, $then: DateTime!) {
    allCustomSlots(
      orderBy: startTime_DESC
      filter: {
        AND: [
          { doctor: { id: $doctorId } }
          { startTime_gte: $now }
          { startTime_lte: $then }
        ]
      }
    ) {
      id
      startTime
      slotTypes {
        id
        name
        duration
      }
      doctor {
        id
      }
    }
  }
`;
const GET_SPECIAL_SLOTS = gql`
  query GetSpecialDaySlotQuery($doctorId: ID!) {
    allSpecialDays(filter: { AND: [{ doctor: { id: $doctorId } }] }) {
      id
      date
      endDate
      dayTemplate {
        id
        name
        hours {
          time
          slotTypes {
            id
            name
          }
        }
      }
      doctor {
        id
      }
    }
  }
`;

export default compose(
  graphql(GET_CUSTOM_SLOTS, {
    name: "getCustomSlots",
    options: ({ doctorId, selectedRdvDate, selectedView }) => {
      if (selectedView === "day") {
        let now = moment(selectedRdvDate).clone().startOf("day");
        let then = moment(selectedRdvDate).clone().endOf("day");
        return {
          variables: { doctorId, now, then },
          fetchPolicy: "cache-and-network",
        };
      }
      let now = moment(selectedRdvDate).startOf("week");
      let then = now.clone().add(7, "days");
      return {
        variables: { doctorId, now, then },
        fetchPolicy: "cache-and-network",
      };
    },
  }),
  graphql(GET_SPECIAL_SLOTS, {
    name: "getSpecialDays",
    options: ({ doctorId /*, selectedRdvDate, selectedView*/ }) => {
      /*if (selectedView === "day") {
        let now = moment(selectedRdvDate)
          .clone()
          .startOf("day");
        let then = moment(selectedRdvDate)
          .clone()
          .endOf("day");
        return {
          variables: { doctorId, now, then },
          fetchPolicy: "cache-and-network"
        };
      }
      let now = moment(selectedRdvDate).startOf("week");
      let then = now.clone().add(7, "days");*/
      return {
        variables: { doctorId /*, now, then*/ },
        fetchPolicy: "cache-and-network",
      };
    },
  }),
  graphql(ALL_SLOTS, {
    name: "allSlotsQuery",
    options: ({ doctorId, selectedRdvDate, selectedView }) => {
      if (selectedView === "day") {
        let now = moment(selectedRdvDate).clone().startOf("day");
        let then = moment(selectedRdvDate).clone().endOf("day");
        return {
          variables: { doctorId, now, then },
          fetchPolicy: "cache-and-network",
        };
      }
      let now = moment(selectedRdvDate).startOf("week");
      let then = now.clone().add(7, "days");
      return {
        variables: { doctorId, now, then },
        fetchPolicy: "cache-and-network",
      };
    },
  }),
  graphql(GET_SELECTED_RDV, {
    name: "getSelectedRdv",
    options: { fetchPolicy: "cache-only" },
  }),
  graphql(UPDATE_RDV_SELECT_DATE, {
    name: "updateRdvSelectDate",
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(UPDATE_RDV_SELECT, {
    name: "updateRdvSelect",
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(UPDATE_RDV_SELECT_TYPE, {
    name: "updateRdvSelectType",
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(UPDATE_SLOT, {
    name: "updateSlot",
  })
)(DoctorCalendar);



// WEBPACK FOOTER //
// ./src/components/utilities/DoctorCalendar.js